import { useActionTypesStore } from '../stores/actionTypesStore';
import { useImmutableDataFetchHook } from '../utilities/immutableDataFetchStore';

export const useActionTypes = () =>
  useImmutableDataFetchHook(useActionTypesStore, undefined);
